<template>
  <div>
    <div class="config-item__quantity d-flex align-items-center@medium">
      <button @click="minus" class="btn btn--square btn--icon" type="button">
        <span class="sr-only">{{ 'txtMinus'|translate }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" class="svg-icon svg-icon--large">
          <circle cx="18" cy="18" r="18" fill="#3a3a39"/>
          <path d="M25.51 17H10.49c-.54 0-.98.44-.98.98s.44.98.98.98h15.02c.54 0 .98-.44.98-.98s-.44-.98-.98-.98z"
                fill="#fff"/>
        </svg>
      </button>

      <input type="number" min="1"
            @input="validate" :value="inputValue" class="input--small">
      <button @click="plus" class="btn btn--square btn--icon" type="button">
        <span class="sr-only">{{ 'txtPlus'|translate }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" class="svg-icon svg-icon--large">
          <circle cx="18" cy="18" r="18" fill="#3a3a39"/>
          <path
              d="M25.51 17.03h-6.54v-6.54c0-.54-.44-.98-.98-.98s-.98.44-.98.98v6.54h-6.53c-.54 0-.98.44-.98.98s.44.98.98.98h6.53v6.54c0 .54.44.98.98.98s.98-.44.98-.98v-6.54h6.54c.54 0 .98-.44.98-.98s-.44-.98-.98-.98z"
              fill="#fff"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: false
    },
    min: {
      type: Number,
      default: 0,
      required: false
    },
    max: {
      type: Number,
      default: 200,
      required: false
    },
    value: {
      type: Number,
      default: 0
    }
  },
  watch: {
    inputValue: function() {
      this.$emit("change", this.inputValue )
    }
  },
  data() {
    return {
      inputValue: this.value,
      inputDebounce: undefined
    }
  },
  methods: {
    emitChange(value) {
      if(!value) return;

    },
    plus() {
      if (this.max === undefined || (this.inputValue < this.max)) {
        this.inputValue += 1
      }
    },
    minus() {
      if (this.inputValue > this.min) {
        this.inputValue -= 1
      }
    },
    validate(event) {
      clearTimeout(this.inputDebounce);
      this.inputDebounce = setTimeout(() => {
        const value = event.target.valueAsNumber;
        if(value < this.min) {
          event.target.value = this.min
          this.inputValue = this.min
        } else if(value > this.max) {
          event.target.value = this.max;
          this.inputValue = this.max
        } else {
          this.inputValue = value
        }
      }, 500)
    }
  }
}
</script>